import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import BigModal from '../../../../components/Modals/BigModal'
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material'

const EditRow = ({
  row,
  categoryName,
  data,
  setData,
  setChangesPresent,
  open,
  onClose,
  vehicleTypeOptions,
  isVehicleCleans,
}) => {
  const [fields, setFields] = useState({})
  const [fieldDuplicate, setFieldDuplicate] = useState(false)

  useEffect(() => {
    row?.item && setFields(row.item)
  }, [row])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (
      row.item.title !== fields.title &&
      data[categoryName].map((x) => x.title).includes(fields.title)
    ) {
      setFieldDuplicate(true)
    } else {
      setData((prev) => ({
        ...prev,
        [categoryName]: data[categoryName].reduce(
          (accumulator, object, index) => {
            if (index === row.index) {
              accumulator.push(fields)
            } else {
              accumulator.push(object)
            }
            return accumulator
          },
          []
        ),
      }))
      onClose()
      setChangesPresent(true)
    }
  }

  const handleDelete = () => {
    setData((prev) => ({
      ...prev,
      [categoryName]: data[categoryName].reduce(
        (accumulator, object, index) => {
          if (index !== row.index) {
            accumulator.push(object)
          }
          return accumulator
        },
        []
      ),
    }))
    onClose()
    setChangesPresent(true)
  }

  return (
    <BigModal open={open} onClose={onClose}>
      <Stack gap={1} component="form" onSubmit={handleSubmit}>
        <Typography variant="title2">Edit Field in {categoryName}</Typography>
        <TextField
          value={fields?.title ?? ''}
          label="Title"
          error={fieldDuplicate}
          autoFocus
          helperText={
            fieldDuplicate ? 'Field Already Exists' : 'E.g. Stretcher'
          }
          autoComplete="off"
          required
          InputLabelProps={{ required: false }}
          onChange={(e) =>
            setFields((prev) => ({ ...prev, title: e.target.value }))
          }
        />
        {!isVehicleCleans && (
          <TextField
            value={fields?.standard ?? ''}
            label="Standard"
            helperText="E.g. Check functioning and Service Date"
            autoComplete="off"
            required
            InputLabelProps={{ required: false }}
            onChange={(e) =>
              setFields((prev) => ({ ...prev, standard: e.target.value }))
            }
          />
        )}
        {isVehicleCleans && (
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Clean Types:</Typography>
            </Grid>
            {['Interim', 'Deep', 'Decontamination'].map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        fields?.cleanType
                          ? fields?.cleanType?.includes(type)
                          : false
                      }
                      onChange={(e) =>
                        setFields((prev) => ({
                          ...prev,
                          cleanType: e.target.checked
                            ? [...prev.cleanType, type]
                            : prev.cleanType.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
        {isVehicleCleans && (
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Applicable To:</Typography>
            </Grid>
            {vehicleTypeOptions?.map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        fields?.vehicleType
                          ? fields?.vehicleType?.includes(type)
                          : false
                      }
                      onChange={(e) =>
                        setFields((prev) => ({
                          ...prev,
                          vehicleType: e.target.checked
                            ? [...prev.vehicleType, type]
                            : prev.vehicleType.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
        {!isVehicleCleans && (
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Applicable To:</Typography>
            </Grid>
            {vehicleTypeOptions?.map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        fields?.applicableTo
                          ? fields?.applicableTo?.includes(type)
                          : false
                      }
                      onChange={(e) =>
                        setFields((prev) => ({
                          ...prev,
                          applicableTo: e.target.checked
                            ? [...prev.applicableTo, type]
                            : prev.applicableTo.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}

        <Button
          type="button"
          variant="outlined"
          color="error"
          onClick={handleDelete}
        >
          Delete this Field
        </Button>
        <Button type="submit" variant="contained" color="success">
          {/* Cleaning edits are only kept once the page itself is saved. */}
          {isVehicleCleans ? 'Apply' : 'Save Changes'}
        </Button>
      </Stack>
    </BigModal>
  )
}

export default EditRow
